import React      from 'react';
import classNames from 'classnames';

import { useModal }   from '../../../providers/modal';
import { useSidebar } from '../../../providers/sidebar';

function Backdrop() {
  const { open }              = useModal();
  const { show: showSidebar } = useSidebar();

  const show = open || showSidebar;
  if (show) {
    return (
      <div className={classNames('backdrop', { show })} />
    );
  }

  return null;
}

export default Backdrop;